import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueYoutube from 'vue-youtube'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import axios from 'axios'
import VueObserveVisibility from 'vue-observe-visibility'
import 'element-closest-polyfill'

Vue.use(VueObserveVisibility)
Vue.use(VueYoutube)

import './functions.js'
import './assets/scss/app.scss'
import './registerServiceWorker'

Vue.config.productionTip = false

if (process.env.LIVE_ENVIRONMENT) {
    Bugsnag.start({
        apiKey: '30025a173d6a56be7f871e8b50f3cbe2',
        plugins: [new BugsnagPluginVue()],
        releaseStage: process.env.LIVE_ENVIRONMENT,
        enabledReleaseStages: ['production', 'staging'],
    })
    Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
}

Vue.prototype.$apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000'

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
